import { PARTICLE_IMAGE_RULES, PARTICLE_SHAPE_TYPES } from '../components/pages/CreatePage/CreatePageConstants';
import { PARTICLE_ASSETS } from '../components/pages/CreatePage/Preview/elements/particles/ParticleAssets';
import { getEmojiImagePath } from './emojiUtils';
import { DEFAULT_EMOJI_UNICODE } from '../components/pages/CreatePage/components/VideoElementsEditor/Particles/constants/EmojiConstants';

export const validateParticleImage = (file) => {
    return new Promise((resolve, reject) => {
        const { ALLOWED_TYPES, MAX_SIZE_KB, MIN_DIMENSION_PX, MAX_DIMENSION_PX } = PARTICLE_IMAGE_RULES;
        const formatNames = ALLOWED_TYPES.map(type => type.split('/')[1].toUpperCase()).join(', ');
    
        if (!ALLOWED_TYPES.includes(file.type)) {
            return reject(`Supported formats: ${formatNames}`);
        }
        if (file.size > MAX_SIZE_KB * 1024) {
            return reject(`File size must be less than ${MAX_SIZE_KB}KB`);
        }

        const img = new Image();
        const reader = new FileReader();
        const cleanupImage = () => {
            img.onload = null;
            img.onerror = null;
            img.src = '';
        };

        reader.onload = (e) => {
            img.onload = () => {
                const { width, height } = img;
                
                cleanupImage();
            
                if (width < MIN_DIMENSION_PX || height < MIN_DIMENSION_PX) {
                    return reject(`Image must be at least ${MIN_DIMENSION_PX}x${MIN_DIMENSION_PX} pixels`);
                }
                if (width > MAX_DIMENSION_PX || height > MAX_DIMENSION_PX) {
                    return reject(`Image must be at most ${MAX_DIMENSION_PX}x${MAX_DIMENSION_PX} pixels`);
                }

                resolve(e.target.result);
            };
            
            img.onerror = () => {
                cleanupImage();
                reject('Failed to load image');
            };
            
            img.src = e.target.result;
        };
        
        reader.onerror = () => reject('Failed to read file');
        reader.readAsDataURL(file);
    });
};

export const getParticleShapeSrc = (shape, mediaData) => {
    switch (shape) {
        case PARTICLE_SHAPE_TYPES.HEART:
            return PARTICLE_ASSETS.HEART_BASIC;
        case PARTICLE_SHAPE_TYPES.STAR:
            return PARTICLE_ASSETS.STAR_BASIC;
        case PARTICLE_SHAPE_TYPES.NOTE:
            return PARTICLE_ASSETS.NOTE_BASIC;
        case PARTICLE_SHAPE_TYPES.EMOJI:
            return mediaData || getEmojiImagePath(DEFAULT_EMOJI_UNICODE);
        case PARTICLE_SHAPE_TYPES.CUSTOM:
            return mediaData || PARTICLE_ASSETS.CIRCLE_BASIC;
        case PARTICLE_SHAPE_TYPES.CIRCLE:
        default:
            return PARTICLE_ASSETS.CIRCLE_BASIC;
    }
};